export enum ItRequisitionStatusCodes {
  OPEN = 1,
  AWAITING_APPROVAL,
  AWAITING_SIM_CARD_FROM_ETISALAT,
  AWAITING_APPROVAL_OF_IT_MANAGER_TH,
  AWAITING_APPROVAL_OF_PAYROLL_ADMIN,
  AWAITING_APPROVAL_OF_ADMIN_MANAGER,
  ISSUED_TO_EMPLOYEE,
  REJECTED,
  CANCELLED,
  AWAITING_CONFIGURATION,
  EMAIL_CONFIGURED,
  AWAITING_FOR_EMAIL_CREATION,
  AWAITING_ISSUANCE,
  AWAITING_APPROVAL_OF_CFO,
  AWAITING_APPROVAL_OF_SYSTEM_ANALYST,
  UNDER_PROCESS,
  USER_CREATED,
  AWAITING_VERIFICATION,
  AWAITING_ISSUENCE_OF_STORE_KEEPER,
  AWAITING_APPROVAL_OF_ASSET_CONTROLLER,
  APPROVED,
  AWAITING_APPROVAL_OF_IT_MANAGER_REA,
  AWAITING_APPROVAL_OF_INVENTORY_ADMIN,
  AWAITING_APPROVAL_OF_FINANCE_MANAGER,
  AWAITING_FOR_EMAIL_CONCELLATION,
  AWAITING_APPROVAL_OF_ERP_ANALYST,
  AWAITING_FOR_SIM_CARD_CANCELLATION,
  AWAITING_FOR_SOFTWARE_LICENSE_REMOVAL,
  AWAITING_FOR_DATA_BACKUP,
  AWAITING_TO_REMOVE_TA_ACCESS,
}
